<template>
  <div id="product-form">
    <!-- <h1>Order your cards Today!</h1> -->
    <b-form-group class="not-too-wide" label="quantity">
      <b-form-radio-group v-model="quantity" buttons :options="quantityOptions" />
    </b-form-group>
    <b-form-group class="not-too-wide" label="corners">
      <b-form-radio-group v-model="corners" buttons :options="cornerOptions" />
    </b-form-group>

    <div class="price not-too-wide" v-if="price">
      <label>Your price:
        <div class="amount">${{price.toFixed(2)}}</div>
      </label>
      <b-button
        :disabled="flags.legacy"
        :title="flags.legacy ? 'Cannot start order on IE11' : ''"
        variant="default"
        @click="startOrder">Start Order</b-button>
    </div>

    <div class="standard-options">
      <div class="square">
        <img class="icons" src="/static/images/product/icons/delivery.svg" id="delivery">
        <div class="icon-text">Free Delivery</div>
      </div>
      <div class="square">
        <img class="icons" src="/static/images/product/icons/backside.svg" id="backsides">
        <div class="icon-text">Free backsides</div>
      </div>
      <div class="square">
        <img class="icons" src="/static/images/product/icons/trust.svg" id="care">
        <div class="icon-text">Handled with care</div>
      </div>

    </div>

  </div>
</template>

<script>
import { products } from "@/services/products.js";
import { uniq, flatten, sortBy } from "lodash";
import { mapActions, mapGetters } from "vuex";
import { compressed } from "@/lib/selectedProduct";
import { viewedPricing } from "@/lib/track/events";

export default {
  props: ["paper"],
  data() {
    return {
      products: [],
      quantity: 50,
      corners: "Square"
    };
  },
  computed: {
    ...mapGetters(['flags']),
    price() {
      // May return undefined!
      let info = this.infoForSides[1] || this.infoForSides[2];
      return info && info.price;
    },
    twoSidedPrice() {
      // If different, return the price for a 2 sided card.
      // Some products may be one-sided only or two sided only.
      // In those cases this always returns null.
      let { 1: one, 2: two } = this.infoForSides;
      if (!one || !two) return null;
      return one.price !== two.price ? two.price : null;
    },
    quantityOptions() {
      let quantities = this.selectedProducts.map(p => Object.keys(p.prices));
      return sortBy(uniq(flatten(quantities)), parseInt);
    },
    cornerOptions() {
      // Always put square first
      // reverse the array so we sort by highest index fisrt and unfound items (-1) are last
      let order = ["Square", "Rounded"].reverse();
      let sortFn = (a, b) => order.indexOf(b) - order.indexOf(a);
      return uniq(this.selectedProducts.map(p => p.attrs.corners)).sort(sortFn);
    },
    selectedProducts() {
      return this.products.filter(({ name }) => name === this.paper);
    },
    infoForSides() {
      // Return url, price for 1 or 2 sides {1: {url: ..., price: ...}, 2: ...}
      let result = {};
      console.log(this.paper);
      for (let p of this.selectedProducts) {
        let price = p.prices[this.quantity];
        let url = p.urls[this.quantity];

        if (p.attrs.corners === this.corners) {
          result[p.attrs.sides] = { price, url };
        } else {
          console.log("no corners match", p.attrs.corners, this.corners);
        }
      }
      console.log("infoForSides->", result);
      return result;
    }
  },
  methods: {
    ...mapActions(["selectProduct"]),
    async loadProducts() {
      // TODO this loads all products
      this.products = this.decorateProducts(await products("any"));
    },
    decorateProducts(products) {
      // decorate the products with an unpacked attrs, derived from product.attributes
      // same with prices
      for (let p of products) {
        p.attrs = {};
        for (let { sku_tag } of p.product.attributes) {
          let [key, value] = sku_tag.split(":");
          p.attrs[key] = value;
        }
        p.prices = {};
        p.urls = {};
        for (let { quantity, retail_price, stockrecord } of p.product.prices) {
          p.prices[quantity] = retail_price;
          p.urls[quantity] = stockrecord.product;
        }
      }
      return products;
    },
    async startOrder() {
      let selectedInfo = {
        quantity: this.quantity,
        1: this.infoForSides[1] && this.infoForSides[1].url,
        2: this.infoForSides[2] && this.infoForSides[2].url
      };
      let url = "/upload/" + compressed(selectedInfo);
      if (this.$route.query.design) url += "/" + this.$route.query.design;
      this.$router.push(url);
    }
  },
  async created() {
    this.loadProducts();
  },
  mounted() {
    viewedPricing('catalog-page');
  }
};
</script>

<style lang="scss" scoped>
@import '~scss/colors.scss';

#product-form {
  z-index: 3;
  background:$frost-0;
  text-align: center;
  color: $white;
  padding-top: 2.5em;
 .not-too-wide {
      display:block;
    }
}


h1 {
  font-size: 1.2em;
  padding: 0 0.5em;
  text-align: left;
  line-height: 1.4em;
  text-transform: uppercase;
}

.price {
  display: flex;
  justify-content: space-between;
  padding: 0.5em 1em;

  label {
    color: #595b5b;
    font-size: small;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-right: 1em;
  }
  .amount {
    font-size: 21px;
  }
}

@media only screen and (max-width: 992px) {
  // When showing below the product, minimize vertical space
  //
  #product-form {
    padding-top: 0;
    .not-too-wide {
      max-width: 500px;
      margin: 1em auto;
    }
    label{
      display:inline-flex;
      justify-content: space-between;
      min-width:150px;
      align-items: center;


    }
  }
}

  @media only screen and (max-device-width: 575.98px) {
    .price {
      position: relative;
      display: flex;
      padding: 0;
      padding-top: 0.5rem;
    }
    .amount {
      font-size: 20px;
    }
    .btn.btn.btn-default {
      margin-top: 0.2rem;
      padding: 1em;
    }
  }

#product-form.qtybox {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}


.standard-options {
  display: block;
  margin: 1em auto;
  height: auto;
}

@media (max-width: 992px) {
  .standard-options {
    display: none;
  }
}

.square {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 50px;
  padding: 0.5em 0 0.5em 3em;
  margin: 1em auto;
  opacity: 0.5;
}

.square:first-child{
  margin-top:3em;
}

.icons {
  width: 30%;
  height: 32px;
}

.icon-text {
  display: flex;
  align-items: center;
  height: auto;
  font-size: 14px;
  color:$black-0;
}

#delivery {
  transform: scale(1);
}

#backsides {
  transform: scale(0.85);
}

#care {
  transform: scale(1);
}
</style>
<style lang="scss">
@import '~scss/colors.scss';
// This needs to affect the form-group within the b-form-group,
// which won't happen unless we use unscoped css
#product-form {
  .form-group {
    border: none;
    padding: 0 1em 1em 1em;
  }
  .col-form-legend {
    color: #595b5b;
    font-size: small;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }
  fieldset {
    margin: 0;
    padding: 0;
  }
  .btn-group {
    width: 101%;
    label {
      flex-grow: 1;
    }
  }

  @media only screen and (max-width:992px) {
    .form-group {
      padding: 0 2.5em;
  }
  }

  @media only screen and (max-device-width: 575.98px) {
    fieldset {
      margin: 0 0 0.5em 0;
      padding: 0;
    }
    .col-form-legend {
      text-align: left;
      padding-bottom: 0px;
    }
    .form-group {
      padding: 0;
    }
  }

  // Buttons are used to provide the radio group
  // Override the application level button look (square with caps)
  .btn-group[role="radiogroup"] {
    border: 1px solid #ddd;

    label.btn {
      box-shadow: none !important;
      font-weight: normal;
      text-transform: uppercase;
      border-radius: 0;
      // font-size: 14px;
      line-height: 2.5em;
      padding: 0 1em;
      height: auto;
      letter-spacing: 0.5px;
      outline: none !important;
      background-color: #f8f8f8;
      color: #ccc;
      border: none;
      cursor: pointer;
      &.active {
        background-color: white;
        color: black;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homepage/businesscards/shared/QtyPriceForm.vue